import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  InputAdornment,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PropTypes from "prop-types";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { gridSpacing } from "../../../../../store/constants";
import TextField from "../../../../../utils/ui-components/FormsUI/TextField";
// import {ConfigurationService} from '../../../../../assets/_services/configuration-service';
import { openSuccessDialog } from "../../../../../utils/ui-components/pop-ups/SuccessDialog";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import IconButton from "@mui/material/IconButton";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { UserService } from "../../../../../assets/_services/user-service";
import CheckboxWrapper from "../../../../../utils/ui-components/FormsUI/Checkbox";
import { UserEditValues } from ".";
import RadioGroupWrapper from "../../../../../utils/ui-components/FormsUI/RadioGroup";

const operatorLabels: Record<number, string> = {
  1: "Robi",
  2: "Teletalk",
  3: "Banglalink",
  4: "Grameenphone",
};

DataCredentialsManagement.propTypes = {
  id: PropTypes.number.isRequired,
  userId: PropTypes.string,
  title: PropTypes.string.isRequired,
  operationCosts: PropTypes.object,
  fetchData: PropTypes.func.isRequired,
};

function DataCredentialsManagement({ id, operationCosts, title, userId, fetchData }: any) {
  const theme: any = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down("md"));
  const [expanded, setExpanded] = React.useState<string | false>(id);
  const [isLoading, setIsLoading] = useState(false);

  const [defaultOperator, setDefaultOperator] = useState<
    {
      value: number | string;
      label: string;
    }[]
  >([]);

  useEffect(() => {
    setDefaultOperator(
      Object.entries(operationCosts.smsOperatorConfguraion)
        .filter(([_, value]) => typeof value === "object" && value !== null && "isUse" in value && (value as any).isUse === true)
        .map(([_, value]) => {
          const operator = value as { systemOperatorId: number };
          return {
            value: operator.systemOperatorId,
            label: operatorLabels[operator.systemOperatorId],
          };
        })
    );
  }, [operationCosts]);

  const [passwordShowOperator, setPasswordShowOperator]: any = React.useState({
    1: { showPassword: false, showConfirmPassword: false },
    2: { showPassword: false, showConfirmPassword: false },
    3: { showPassword: false, showConfirmPassword: false },
    4: { showPassword: false, showConfirmPassword: false },
  });

  const handleClickShowPasswordOperator = (id: number) => {
    setPasswordShowOperator((prevState: any) => ({
      ...prevState,
      [id]: {
        ...prevState[id],
        showPassword: !prevState[id].showPassword,
      },
    }));
  };

  const handleChange = (panelID: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panelID : false);
  };

  const FORM_VALIDATION = Yup.object().shape({
    rewardOperatorConfguraion: Yup.object()
      .shape({
        all: Yup.boolean().required("Required"),
        robi: Yup.object().shape({
          isUse: Yup.boolean().required("Required"),
          userName: Yup.string().when("isUse", {
            is: (val: any) => val,
            then: (schema: any) => schema.required("Username is required"),
            otherwise: (schema: any) => schema.notRequired(),
          }),
          // .matches(/^[a-zA-Z0-9]*$/, "Contains only letters and numbers"),
          password: Yup.string()
            .max(255)
            .when(["isUse", "isUpdate"], {
              is: (isUse: boolean, isUpdate: boolean) => isUse === true && isUpdate === false,
              then: (schema: any) => schema.required("Password is required"),
              otherwise: (schema: any) => schema.notRequired(),
            }),
        }),
        tl: Yup.object().shape({
          isUse: Yup.boolean().required("Required"),
          userName: Yup.string().when("isUse", {
            is: (val: any) => val,
            then: (schema: any) => schema.required("Username is required"),
            otherwise: (schema: any) => schema.notRequired(),
          }),
          // .matches(/^[a-zA-Z0-9]*$/, "Contains only letters and numbers"),
          password: Yup.string()
            .max(255)
            .when(["isUse", "isUpdate"], {
              is: (isUse: boolean, isUpdate: boolean) => isUse === true && isUpdate === false,
              then: (schema: any) => schema.required("Password is required"),
              otherwise: (schema: any) => schema.notRequired(),
            }),
        }),
        bl: Yup.object().shape({
          isUse: Yup.boolean().required("Required"),
          userName: Yup.string().when("isUse", {
            is: (val: any) => val,
            then: (schema: any) => schema.required("Username is required"),
            otherwise: (schema: any) => schema.notRequired(),
          }),
          // .matches(/^[a-zA-Z0-9]*$/, "Contains only letters and numbers"),
          password: Yup.string()
            .max(255)
            .when(["isUse", "isUpdate"], {
              is: (isUse: boolean, isUpdate: boolean) => isUse === true && isUpdate === false,
              then: (schema: any) => schema.required("Password is required"),
              otherwise: (schema: any) => schema.notRequired(),
            }),
          clientId: Yup.string().when("isUse", {
            is: (val: any) => val,
            then: (schema: any) => schema.required("Client ID is required"),
            otherwise: (schema: any) => schema.notRequired(),
          }),
          grantType: Yup.string().when("isUse", {
            is: (val: any) => val,
            then: (schema: any) => schema.required("Grant type is required"),
            otherwise: (schema: any) => schema.notRequired(),
          }),
          scope: Yup.string().when("isUse", {
            is: (val: any) => val,
            then: (schema: any) => schema.required("Scope is required"),
            otherwise: (schema: any) => schema.notRequired(),
          }),
          clientSecret: Yup.string().when("isUse", {
            is: (val: any) => val,
            then: (schema: any) => schema.required("Client secret is required"),
            otherwise: (schema: any) => schema.notRequired(),
          }),
          senderMsisdn: Yup.string()
            .matches(/^((880|0)?(1){1}[3456789]{1}(\d){8},?)+$/, "Invalid mobile numbers pattern detected")
            .when("isUse", {
              is: (val: any) => val,
              then: (schema: any) => schema.required("Sender Msisdn is required"),
              otherwise: (schema: any) => schema.notRequired(),
            }),
        }),
        gp: Yup.object().shape({
          isUse: Yup.boolean().required("Required"),
          clientId: Yup.string().when("isUse", {
            is: (val: any) => val,
            then: (schema: any) => schema.required("Client ID is required"),
            otherwise: (schema: any) => schema.notRequired(),
          }),
          grantType: Yup.string().when("isUse", {
            is: (val: any) => val,
            then: (schema: any) => schema.required("Grant type is required"),
            otherwise: (schema: any) => schema.notRequired(),
          }),
          clientSecret: Yup.string().when("isUse", {
            is: (val: any) => val,
            then: (schema: any) => schema.required("Client secret is required"),
            otherwise: (schema: any) => schema.notRequired(),
          }),
        }),
      })
      .test("valid", "valid", function (this: Yup.TestContext) {
        const { rewardOperatorConfguraion } = this.parent;
        const { robi, tl, bl, gp } = rewardOperatorConfguraion;
        const isAnyUseTrue = [robi, tl, bl, gp].some((item) => item.isUse === true);
        return isAnyUseTrue;
      }),
  });

  const updateUserDataConfiogurations = (values: UserEditValues, setSubmitting: any) => {
    setIsLoading(true);
    const formData = {
      userId: values.id,
      isAllOperatorsAllowed: values.rewardOperatorConfguraion.all ? 1 : 0,
      isDataRewardAvailable: values.enableRewardCampaignCreation ? 1 : 0,
      dataSystemOperatorConfigurations: [
        values.rewardOperatorConfguraion.robi.isUse && {
          systemOperatorId: values.rewardOperatorConfguraion.robi.systemOperatorId,
          userName: values.rewardOperatorConfguraion.robi.userName,
          password: values.rewardOperatorConfguraion.robi.password === "" ? null : values.rewardOperatorConfguraion.robi.password,
        },
        values.rewardOperatorConfguraion.tl.isUse && {
          systemOperatorId: values.rewardOperatorConfguraion.tl.systemOperatorId,
          userName: values.rewardOperatorConfguraion.tl.userName,
          password: values.rewardOperatorConfguraion.tl.password === "" ? null : values.rewardOperatorConfguraion.tl.password,
        },
        values.rewardOperatorConfguraion.bl.isUse && {
          systemOperatorId: values.rewardOperatorConfguraion.bl.systemOperatorId,
          userName: values.rewardOperatorConfguraion.bl.userName,
          password: values.rewardOperatorConfguraion.bl.password === "" ? null : values.rewardOperatorConfguraion.bl.password,
          clientId: values.rewardOperatorConfguraion.bl.clientId,
          grantType: values.rewardOperatorConfguraion.bl.grantType,
          scope: values.rewardOperatorConfguraion.bl.scope,
          clientSecret: values.rewardOperatorConfguraion.bl.clientSecret,
          senderMsisdn: values.rewardOperatorConfguraion.bl.senderMsisdn,
        },
        values.rewardOperatorConfguraion.gp.isUse && {
          systemOperatorId: values.rewardOperatorConfguraion.gp.systemOperatorId,
          clientId: values.rewardOperatorConfguraion.gp.clientId,
          clientSecret: values.rewardOperatorConfguraion.gp.clientSecret,
          grantType: values.rewardOperatorConfguraion.gp.grantType,
        },
      ].filter((item) => typeof item !== "boolean"),
    };
    UserService.updateUserDataConfigurations(formData).then((response) => {
      if (response.isSuccess) {
        setSubmitting(false);
        setIsLoading(false);
        openSuccessDialog("Success", "Data operator configuration updated successfully");
        fetchData();
      } else {
        setIsLoading(false);
        setSubmitting(false);
      }
    });
  };

  return (
    <Box>
      <Accordion expanded={expanded === id.toString()} onChange={handleChange(id.toString())}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: "#ffff" }} />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{
            backgroundColor: theme.palette.primary.main,
          }}
        >
          <Typography fontWeight={"bold"} variant="h4" color={"#ffff"}>
            Data Operators Configuration
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Formik
            initialValues={{ ...operationCosts }}
            enableReinitialize={true}
            validationSchema={FORM_VALIDATION}
            onSubmit={(values: UserEditValues, { setSubmitting }) => {
              updateUserDataConfiogurations(values, setSubmitting);
            }}
          >
            {({ values, dirty, isSubmitting, isValid, errors, setFieldValue, setErrors }) => (
              <Form>
                <Grid container spacing={gridSpacing} justifyContent={"center"}>
                  <Grid item xs={12}>
                    <CheckboxWrapper
                      customHandleChange={(e: any) => {
                        if (e.target.checked) {
                          setFieldValue("rewardOperatorConfguraion", {
                            all: true,
                            robi: {
                              ...values.rewardOperatorConfguraion.robi,
                              isUse: true,
                            },
                            tl: {
                              ...values.rewardOperatorConfguraion.tl,
                              isUse: true,
                            },
                            bl: {
                              ...values.rewardOperatorConfguraion.bl,
                              isUse: true,
                            },
                            gp: {
                              ...values.rewardOperatorConfguraion.gp,
                              isUse: true,
                            },
                          });
                        } else {
                          setFieldValue("rewardOperatorConfguraion", {
                            all: false,
                            robi: {
                              ...values.rewardOperatorConfguraion.robi,
                              isUse: false,
                            },
                            tl: {
                              ...values.rewardOperatorConfguraion.tl,
                              isUse: false,
                            },
                            bl: {
                              ...values.rewardOperatorConfguraion.bl,
                              isUse: false,
                            },
                            gp: {
                              ...values.rewardOperatorConfguraion.gp,
                              isUse: false,
                            },
                          });
                        }
                      }}
                      legend={"All Operators"}
                      name={"rewardOperatorConfguraion.all"}
                      sx={{ pr: 0 }}
                    />
                  </Grid>

                  <Grid item lg={12} container columnSpacing={1}>
                    <Grid item lg={2} md={2} sm={3} xs={3}>
                      <CheckboxWrapper
                        customHandleChange={(e: any) => {
                          if (
                            e?.target.checked &&
                            values.rewardOperatorConfguraion.tl.isUse &&
                            values.rewardOperatorConfguraion.bl.isUse &&
                            values.rewardOperatorConfguraion.gp.isUse
                          ) {
                            setFieldValue("rewardOperatorConfguraion", {
                              ...values.rewardOperatorConfguraion,
                              all: true,
                              robi: {
                                ...values.rewardOperatorConfguraion.robi,
                                isUse: e?.target.checked,
                              },
                            });
                          } else {
                            setFieldValue("rewardOperatorConfguraion", {
                              ...values.rewardOperatorConfguraion,
                              all: false,
                              robi: {
                                ...values.rewardOperatorConfguraion.robi,
                                isUse: e?.target.checked,
                              },
                            });
                          }
                        }}
                        legend={"Robi"}
                        name={"rewardOperatorConfguraion.robi.isUse"}
                        sx={{ pr: 0 }}
                      />
                    </Grid>
                    <Grid item lg={10} container spacing={1}>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.robi.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.robi.userName"
                          label="Username"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.robi.isUse && values.rewardOperatorConfguraion.robi.isUpdate === false}
                          type={passwordShowOperator[1]?.showPassword ? "text" : "password"}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LockIcon />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton aria-label="toggle password visibility" onClick={() => handleClickShowPasswordOperator(1)} edge="end">
                                  {passwordShowOperator[1]?.showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          name="rewardOperatorConfguraion.robi.password"
                          label="Password"
                          placeholder="Password"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={12} container columnSpacing={1}>
                    <Grid item lg={2} md={2} sm={3} xs={3}>
                      <CheckboxWrapper
                        customHandleChange={(e: any) => {
                          if (
                            e?.target.checked &&
                            values.rewardOperatorConfguraion.robi.isUse &&
                            values.rewardOperatorConfguraion.bl.isUse &&
                            values.rewardOperatorConfguraion.gp.isUse
                          ) {
                            setFieldValue("rewardOperatorConfguraion", {
                              ...values.rewardOperatorConfguraion,
                              all: true,
                              tl: {
                                ...values.rewardOperatorConfguraion.tl,
                                isUse: e?.target.checked,
                              },
                            });
                          } else {
                            setFieldValue("rewardOperatorConfguraion", {
                              ...values.rewardOperatorConfguraion,
                              all: false,
                              tl: {
                                ...values.rewardOperatorConfguraion.tl,
                                isUse: e?.target.checked,
                              },
                            });
                          }
                        }}
                        legend={"Teletalk"}
                        name={"rewardOperatorConfguraion.tl.isUse"}
                        sx={{ pr: 0 }}
                      />
                    </Grid>
                    <Grid item lg={10} container spacing={1}>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.tl.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.tl.userName"
                          label="Username"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.tl.isUse && values.rewardOperatorConfguraion.tl.isUpdate === false}
                          type={passwordShowOperator[1]?.showPassword ? "text" : "password"}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LockIcon />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton aria-label="toggle password visibility" onClick={() => handleClickShowPasswordOperator(1)} edge="end">
                                  {passwordShowOperator[1]?.showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          name="rewardOperatorConfguraion.tl.password"
                          label="Password"
                          placeholder="Password"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={12} container columnSpacing={1}>
                    <Grid item lg={2} md={2} sm={3} xs={3}>
                      <CheckboxWrapper
                        customHandleChange={(e: any) => {
                          if (
                            e?.target.checked &&
                            values.rewardOperatorConfguraion.tl.isUse &&
                            values.rewardOperatorConfguraion.robi.isUse &&
                            values.rewardOperatorConfguraion.gp.isUse
                          ) {
                            setFieldValue("rewardOperatorConfguraion", {
                              ...values.rewardOperatorConfguraion,
                              all: true,
                              bl: {
                                ...values.rewardOperatorConfguraion.bl,
                                isUse: e?.target.checked,
                              },
                            });
                          } else {
                            setFieldValue("rewardOperatorConfguraion", {
                              ...values.rewardOperatorConfguraion,
                              all: false,
                              bl: {
                                ...values.rewardOperatorConfguraion.bl,
                                isUse: e?.target.checked,
                              },
                            });
                          }
                        }}
                        legend={"Banglalink"}
                        name={"rewardOperatorConfguraion.bl.isUse"}
                        sx={{ pr: 0 }}
                      />
                    </Grid>
                    <Grid item lg={10} container spacing={1}>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.bl.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.bl.userName"
                          label="Username"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.bl.isUse && values.rewardOperatorConfguraion.bl.isUpdate === false}
                          type={passwordShowOperator[1]?.showPassword ? "text" : "password"}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <LockIcon />
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton aria-label="toggle password visibility" onClick={() => handleClickShowPasswordOperator(1)} edge="end">
                                  {passwordShowOperator[1]?.showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          name="rewardOperatorConfguraion.bl.password"
                          label="Password"
                          placeholder="Password"
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.bl.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.bl.clientId"
                          label="Client Id"
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.bl.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.bl.grantType"
                          label="Grant Type"
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.bl.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.bl.scope"
                          label="Scope"
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.bl.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.bl.clientSecret"
                          label="Client Secret"
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.bl.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.bl.senderMsisdn"
                          label="Sender Msisdn"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item lg={12} container columnSpacing={1}>
                    <Grid item lg={2} md={2} sm={3} xs={3}>
                      <CheckboxWrapper
                        customHandleChange={(e: any) => {
                          if (
                            e?.target.checked &&
                            values.rewardOperatorConfguraion.tl.isUse &&
                            values.rewardOperatorConfguraion.bl.isUse &&
                            values.rewardOperatorConfguraion.robi.isUse
                          ) {
                            setFieldValue("rewardOperatorConfguraion", {
                              ...values.rewardOperatorConfguraion,
                              all: true,
                              gp: {
                                ...values.rewardOperatorConfguraion.gp,
                                isUse: e?.target.checked,
                              },
                            });
                          } else {
                            setFieldValue("rewardOperatorConfguraion", {
                              ...values.rewardOperatorConfguraion,
                              all: false,
                              gp: {
                                ...values.rewardOperatorConfguraion.gp,
                                isUse: e?.target.checked,
                              },
                            });
                          }
                        }}
                        legend={"Grameenphone"}
                        name={"rewardOperatorConfguraion.gp.isUse"}
                        sx={{ pr: 0 }}
                      />
                    </Grid>
                    <Grid item lg={10} container spacing={1}>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.gp.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.gp.clientId"
                          label="Client Id"
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.gp.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.gp.grantType"
                          label="Grant Type"
                        />
                      </Grid>
                      <Grid item lg={4} md={5} sm={8} xs={9}>
                        <TextField
                          required={values.rewardOperatorConfguraion.gp.isUse}
                          type={"text"}
                          name="rewardOperatorConfguraion.gp.clientSecret"
                          label="Client Secret"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    {!values.rewardOperatorConfguraion.bl.isUse &&
                      !values.rewardOperatorConfguraion.gp.isUse &&
                      !values.rewardOperatorConfguraion.robi.isUse &&
                      !values.rewardOperatorConfguraion.tl.isUse && (
                        <Typography variant="caption" color={"error"}>
                          At least one data reward operator required
                        </Typography>
                      )}
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Stack direction={"row"} justifyContent={"flex-end"}>
                      <Button
                        color="primary"
                        variant="contained"
                        type="submit"
                        size="medium"
                        disabled={!dirty || isSubmitting || !isValid}
                        startIcon={
                          isLoading && (
                            <CircularProgress
                              size={"20px"}
                              sx={{
                                mr: 1,
                                color: "gray",
                              }}
                            />
                          )
                        }
                      >
                        Update
                      </Button>
                    </Stack>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

export default DataCredentialsManagement;
